import React, { useCallback, useEffect, useState ,useRef} from "react";
import { connect } from "react-redux";
import { Popup } from "devextreme-react/popup";
import { Button } from "devextreme-react";
import {
    DataGrid,
    Column,
    Scrolling,
    LoadPanel,
    ColumnChooser,
    Toolbar,
    Item as ToolbarItem,
} from "devextreme-react/data-grid";
import axios from "axios";
import { alert } from "devextreme/ui/dialog";
import { MESSAGES } from "../../../../../common/Messages";
import { PriceLevelColumns } from "../../../../../const/Lookup";

const currency4 = {
    type: "currency",
    precision: 4,
    currency: "USD",
    useGrouping: true,
};

function ItemPricesPopup(props) {
    const { showPopup = {}, setShowPopup, oidc } = props;
    const visible = showPopup.visible === true;
    const accessToken = oidc?.user?.access_token;
    const rItem = showPopup.rItem;
    const [selectedColoumns, setColoumns] = useState(null);
   
    const [rows, setRows] = useState([]);
    const dataGrid = useRef(null);
    const currencyFormat = { type: 'currency', precision: 4, useGrouping: true };

    const loadData = useCallback(async () => {
        if (!rItem || !accessToken) return;
        props.setLoadPanelVisible(true);
        try {
            const item = await axios.get(
                `${window._env_.REACT_APP_APIS}/om/SalesOrderDetailOperations/GetItemPrices`,
                {
                    params: { rItem },
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );
            console.log(item.data);
            if (item.data) {
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/im/PriceCodes/GetPriceCodes`,
                {
                    params: {
                        ItemRowId: item.data.RowId,
                        RPriceTable: item.data.RPriceTable,
                        PriceMethod: item.data.PriceMethod,
                        CalcMethod: item.data.CalcMethod,
                        AverageCost: item.data.AverageCost,
                        StandardCost: item.data.StandardCost,
                        RoundingMethod: item.data.RoundingMethod,
                        RoundingFactor: item.data.RoundingFactor,
                        LastCost: item.data.LastCost,
                        PriceBasis: item.data.PriceBasis,
                        PriceSource: item.data.PriceSource,
                    }
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            if (res.data) {
                let priceLevels = res.data[0]?.NumberOfPriceLevels;
                let cols = [];
                if (priceLevels !== null) {

                    for (let i = 0; i < PriceLevelColumns.length; i++) {
                        const col = PriceLevelColumns[i];
                        cols.push(col);
                        if (col.key === priceLevels) {
                            break;
                        }
                    }
                }
                setColoumns(cols);
                setRows(res.data);
                // Resize grid after data is loaded
                setTimeout(() => {
                    if (dataGrid.current && dataGrid.current.instance) {
                        dataGrid.current.instance().updateDimensions();
                    }
                }, 100);
            } else {
                console.warn(MESSAGES.FETCH_ERROR);
            }
            }
        } catch (err) {
            console.log(err, MESSAGES.FETCH_ERROR);
        }
        finally {
            props.setLoadPanelVisible(false);
        }
    }, [rItem, accessToken]);

    useEffect(() => {
        if (!visible) return;
        setRows([]);
        loadData();
    }, [visible, loadData]);

    const handleHiding = useCallback(() => {
        setShowPopup((prev) => ({ ...prev, visible: false }));
    }, [setShowPopup]);

    if (!visible) {
        return null;
    }

    return (
        <Popup
            visible={visible}
            onHiding={handleHiding}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title="Item Prices"
            width="90vw"
            maxWidth={960}
            height="auto"
            container="#root"
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 200,
                    boxSizing: "border-box",
                }}
            >
                <DataGrid
                    dataSource={rows}
                    keyExpr="RowId"
                    ref={dataGrid}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    hoverStateEnabled={true}
                    showBorders={true}
                    showColumnLines={true}
                    showRowLines={true}
                    height={220}
                >
                    <Scrolling mode="standard" />
                    <Toolbar>
                        <ToolbarItem name="columnChooserButton" location="after" />
                    </Toolbar>
                    <ColumnChooser enabled={true} mode="select" />
                    {selectedColoumns && selectedColoumns.map(col => (
                        <Column
                            key={col.dataField}
                            dataType={col.dataType}
                            dataField={col.dataField}
                            caption={col.caption}
                            format={currencyFormat}
                        />
                    ))}
                    <Column dataField="PriceSource" caption="Price Source" visible={false} />
                    <Column dataField="RPriceTable" caption="R Price Table" visible={false} />
                    <Column dataField="PriceMethod" caption="Price Method" visible={false} />
                    <Column dataField="CalcMethod" caption="Calc Method" visible={false} />
                    <Column dataField="StandardCost" caption="Standard Cost" format={currency4} visible={false} />
                    <Column dataField="AverageCost" caption="Average Cost" format={currency4} visible={false} />
                    <Column dataField="LastCost" caption="Last Cost" format={currency4} visible={false} />
                    <Column dataField="PriceBasis" caption="Price Basis" format={currency4} visible={false} />
                    <Column dataField="RoundingMethod" caption="Rounding Method" visible={false} />
                    <Column dataField="RoundingFactor" caption="Rounding Factor" format={currency4} visible={false} />
                </DataGrid>
                <div
                    style={{
                        padding: "16px",
                        textAlign: "right",
                        borderTop: "1px solid #e0e0e0",
                    }}
                >
                    <Button text="OK" type="default" onClick={handleHiding} width={120} />
                </div>
            </div>
        </Popup>
    );
}

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(ItemPricesPopup);
